import { render } from "./Personnel.vue?vue&type=template&id=0683811c&scoped=true"
import script from "./Personnel.vue?vue&type=script&lang=js"
export * from "./Personnel.vue?vue&type=script&lang=js"

import "./Personnel.vue?vue&type=style&index=0&id=0683811c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0683811c"]])

export default __exports__